import { checkSelectedCount } from "./compare-counter.js";
// ------------------------------------------------------------------------------------------- //
// ------------------------------- Integrate with Compare.js  --------------------------------
// ------------------------------------------------------------------------------------------- //

export function retrieveComparisonIds(id) {


    const getComparison = document.querySelectorAll('[data-comparison]');
   
    // Collects a list of storage
    let compareList = Array.prototype.map.call(
        getComparison, 
        (element, index) =>  (window.sessionStorage.getItem('comparison_id_0' + (index + 1)) == id) ? null : window.sessionStorage.getItem('comparison_id_0' + (index + 1))
     );

    let i = 0;

    // Removes any values that are classified as null
    getComparison.forEach((elem, index) => {
        i = index + 1;

        if(window.sessionStorage.getItem('comparison_id_0' + i) == id) {
            window.sessionStorage.removeItem('comparison0' + i);
            window.sessionStorage.removeItem('comparison_id_0' + i);
            window.sessionStorage.removeItem('comparison_meta_0' + i);
            window.sessionStorage.removeItem('comparison_image_0' + i);
            window.sessionStorage.removeItem('comparison_type_0' + i);

            document.querySelectorAll('#compare-section [data-slot-id="' + id + '"]').forEach((elem) => {
                elem.removeAttribute('data-slot-comparison');
                elem.removeAttribute('style');
                elem.removeAttribute('data-slot-id');
            });

            // Remove active state from checkbox
            let activeCheckbox = document.querySelector('#filter-results ' + '[data-slot-id="' + id + '"]')
            if(activeCheckbox) {
                activeCheckbox.checked = false;
            }
        }

    });
    
    

    return compareList;
}


